import type { Prototype } from "../prototype-types";

export const leighJenningsPrototypes: Prototype[] = [
  {
    id: "lj-pdp",
    name: "LJ PDP",
    path: "/lj/lj-pdp",
    description: "Exploring a new version of the PDP.",
    owner: "Leigh Jennings",
    createdAt: "2026-03-05",
    lastUpdated: "2026-03-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1e2ac44a3360d2bffa66021453844dff9287fd1e2c55b48f3cdcc7b1090a27f9.png",
    creationTool: "claude-code",
  },
];
